<template lang="pug">
  layout(content-style="grey-lighter")
    template(v-slot:toolbar)
      .navbar
        .navbar-start
          .navbar-item
            b-field
              b-radio-button(v-model="filter.status" :native-value="0") Все
              b-radio-button(v-model="filter.status" :native-value="1") Новые
              b-radio-button(v-model="filter.status" :native-value="2") В процессе

            //- b-tabs.mb-0(type="is-toggle" size="is-small")
              b-tab-item.is-white(label="Все" icon="")
              b-tab-item(label="Новые" icon="star-circle-outline")
              b-tab-item(label="В процессе" icon="progress-clock")
              b-tab-item(label="Выполненные" icon="checkbox-marked-circle-outline")
          .navbar-item
            b-switch(v-model="filter.showCompleted") Показывать выполненные

    template(v-slot:content)
      //- .content
      //- h1.header План задач

      section.section.container
        //- h1.title Список задач
        .columns
          .column.is-10.is-offset-1
            //- article.panel.is-primary.has-background-white
              //- p.panel-heading Список задач
            //- p.panel-tabs

            div.mb-20(v-for="group in groupedTasks" :key="group.id")
              .is-block.pb-5
                strong(:class="group.isExpired ? 'has-text-danger' : 'has-text-grey'") {{ group.date }}
                .is-pulled-right
                  small(:class="group.isExpired ? 'has-text-danger' : 'has-text-grey'")
                    | {{ group.isExpired ? 'прошло' : 'через' }} {{ group.dateFromNow }}


              article.panel.is-primary.has-background-white
                a.panel-block.is-block(v-for="task in group.tasks" :key="task.id" :class="task.isComplete ? 'has-background-grey-lighter is-muted' : ''" @click="onTaskClick(task)")

                  b-icon.has-text-grey.mr-10(:icon="task.isComplete ? 'checkbox-marked-circle-outline' : 'checkbox-blank-circle-outline'")
                  //- b-icon(:icon="task.document.file.icon" :type="task.document.file.style")

                  template(v-if="task.document")
                    b-tag.mr-5.is-rounded.is-green
                      b-icon(icon="book" size="is-small")
                      span Метериал
                    span {{ task.document.name }}
                  template(v-else)
                    b-tag.mr-5.is-rounded.is-purple
                      b-icon(icon="comment-question" size="is-small")
                      span Тест
                    span {{ task.test.name }}

                  .is-pulled-right
                    //- b-icon(:icon="task.status.icon" :type="task.status.color")
                    b-tag.is-rounded(:type="task.status.color") {{ task.status.title }}

          //- .column.is-3
            .p-15
            article.panel.is-primary.has-background-light
              //- p.panel-heading Список задач

              .panel-block
                b-tag.is-rounded(type="is-cyan") Новых задач
                b-tag.is-grey.ml-auto 4
              .panel-block
                b-tag.is-rounded(type="is-warning") В процессе
                b-tag.is-grey.ml-auto 2
              .panel-block
                b-tag.is-rounded(type="is-grey") Выполнено
                b-tag.is-grey.ml-auto 2
</template>

<script>
import dayjs from 'dayjs';
import db from '@/db';

export default {
  name: 'view-tasks-list',

  data: () => ({
    tasks: db.tasks,
    filter: {
      showCompleted: true,
      status: 0,
    },
  }),

  computed: {
    groupedTasks() {
      let groups = {};

      this.tasks
        .filter(task => {
          if (!this.filter.showCompleted && task.isComplete) {
            return false;
          }
          return !this.filter.status || this.filter.status === task.status.id;
        })
        .forEach(task => {
          const deadline = dayjs(task.deadline);
          const groupKey = task.deadline;
          // task.deadlineFormated =

          if (!groups[groupKey]) {
            groups[groupKey] = {
              date: deadline.format('D MMMM'),
              isExpired: !dayjs().isBefore(deadline),
              dateFromNow: deadline.fromNow(true),
              tasks: [],
            };
          }
          groups[groupKey].tasks.push(task);
        });

      return Object.values(groups);
    },
  },

  methods: {
    onTaskClick(task) {
      // console.log(task);
      if (task.document) {
        this.$router.push({ name: 'docs.view.read', params: { id: task.document.id } });
      }
    },
  },
};
</script>
